import { ErrorResponse } from '@collinsonx/utils/apolloBooking';
import LayoutError from '@components/LayoutError';
import { createContext, useState } from 'react';
import { IObservable } from 'utils/observer';

interface ErrorProviderProps {
  apolloErrorObservable?: IObservable<ErrorResponse>;
  children: React.ReactNode;
}

type ErrorInfo = {
  button?: string;
  custtomButtonClick?: () => void;
  message?: string;
  mobileMessage?: string;
  title?: string;
};

type ErrorState = {
  error: ErrorInfo | undefined;
  setError: (errorInfo?: ErrorInfo) => void;
};

const defaultConextValue = {
  error: undefined,
  setError: () => {},
};

export const ErrorContext = createContext<ErrorState>(defaultConextValue);

const ErrorProvider: React.FC<ErrorProviderProps> = ({ children }) => {
  const [error, setError] = useState<ErrorInfo | undefined>();

  return (
    <>
      <ErrorContext.Provider
        value={{
          error,
          setError: (val?: ErrorInfo) => setError(val ?? {}),
        }}
      >
        {error ? <LayoutError /> : <>{children}</>}
      </ErrorContext.Provider>
    </>
  );
};

export default ErrorProvider;
